import React, { useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { GlobalContext } from '../lib/GlobalVar';
import { ConsultaUsuario } from '../lib/api';
import { encrypt } from '../lib/aes';
import { BabitaLogo } from './BabitaLogo';
import { caminhoInternoSeguro } from '../lib/retornoLogin';

export default function Login({ redirectTo } = {}) {
    const { login } = useContext(GlobalContext);
    const navigate = useNavigate();
    const location = useLocation();
    // após o login, volta para a página que o usuário tentou acessar (?next=/...), se houver. O valor vem da URL: só vale caminho
    // RELATIVO INTERNO (lib/retornoLogin.js) — a página pública de tutoriais usa isto para a vendedora voltar a ela depois de entrar.
    const paginaPedida = () => {
        try { return caminhoInternoSeguro(new URLSearchParams(location.search).get('next')); } catch (_) { return ''; }
    };
    // vendedora com a senha do ERP (senha_do_erp): sem pagina pedida, entra direto na pagina dela, fora do menu do Central
    const proximaPagina = (u) => paginaPedida() || redirectTo || (u && u.senha_do_erp ? '/vendedora' : '/Dashboard');
    const veioDosTutoriais = /^\/tutoriais(\/|\?|$)/.test(paginaPedida());
    const [usuario, setUsuario] = useState('');
    const [senha, setSenha] = useState('');
    const [loading, setLoading] = useState(false);

    async function entrar() {
        if (!usuario || !senha) {
            return Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Informe login (ou e-mail) e senha.' });
        }
        setLoading(true);
        const resp = await ConsultaUsuario({ US: encrypt(usuario.trim()), PAS: encrypt(senha) });
        setLoading(false);
        if (resp.Error) {
            return Swal.fire({ icon: 'warning', title: 'Atenção', text: resp.Error });
        }
        const u = Array.isArray(resp) ? resp[0] : resp;
        login(u);
        if (u.must_change) {
            await Swal.fire({
                icon: 'info', title: 'Troque sua senha',
                text: 'Este é seu primeiro acesso. Defina uma nova senha antes de continuar.',
                confirmButtonText: 'OK'
            });
            return navigate('/Configuracoes?forcar=senha');
        }
        // Voltando para a pagina que a pessoa pediu (?next=), o login SAI do historico: o Voltar do celular/WebView nao cai de novo nele.
        navigate(proximaPagina(u), { replace: !!paginaPedida() });
    }

    function onSubmit(e) { e.preventDefault(); entrar(); }

    return (
        <form className="login" onSubmit={onSubmit}>
            <div className="login-cover">
                <div className="top">
                    <span>Babita · Central Interna</span>
                    <span className="right">Belo Horizonte · MG</span>
                </div>
                <div className="mid">
                    <div className="wordmark"><BabitaLogo color="var(--bg)"/></div>
                    <div className="tag">— O melhor para quem opera a moda.</div>
                </div>
                <div className="bottom">
                    <span>Babita · v3.0</span>
                    <span className="legal">Acesso protegido · AES + MD5</span>
                </div>
            </div>

            <div className="login-form">
                <div className="inner">
                    <div className="eyebrow" style={{ marginBottom: 20 }}>
                        <span className="num">01</span> Acesso restrito
                    </div>
                    <h2>Bem-vinda.</h2>
                    <p className="greet">Use seu login ou e-mail Babita e a senha corporativa para entrar na central operacional.</p>
                    {veioDosTutoriais && <p className="greet" role="note">Para ver os tutoriais é preciso entrar. Depois de entrar, você volta direto para eles.</p>}

                    <div className="field">
                        <label>Login ou e-mail</label>
                        <input
                            className="input"
                            type="text"
                            value={usuario}
                            onChange={e => setUsuario(e.target.value)}
                            autoComplete="username"
                            placeholder="seu.login ou seu.nome@babita.com.br"
                            autoFocus
                        />
                    </div>

                    <div className="field">
                        <label>Senha</label>
                        <input
                            className="input"
                            type="password"
                            value={senha}
                            onChange={e => setSenha(e.target.value)}
                            autoComplete="current-password"
                        />
                    </div>

                    <button className="btn" type="submit" disabled={loading} style={{ marginTop: 14 }}>
                        {loading ? 'Entrando…' : 'Entrar na central'}
                    </button>

                    <div className="legal" style={{ marginTop: 22 }}>Babita · Central Interna</div>
                </div>
            </div>
        </form>
    );
}
